module.exports = __webpack_public_path__ + "static/media/4.ce70456.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/traditional/home/pc/role/video/4.wav
// module id = CYNy
// module chunks = 0